export default __webpack_public_path__ + "static/media/010910_138.00ed4c6a.jpg";